module.exports = __webpack_public_path__ + "static/assets/28e904c2c9f73c87f80ac5a345f94347.png";